"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPlaceholders = void 0;
function setPlaceholders() {
    var reelFrames = document.getElementsByClassName('reel-frame');
    var _loop_1 = function (i) {
        var frame = reelFrames[i];
        frame.width = 300;
        frame.height = 225;
        var canvasContext = frame.getContext('2d');
        var placeholderImage = new Image();
        placeholderImage.src = "./assets/Placeholder_".concat(i + 1, ".jpg");
        placeholderImage.onload = function () {
            canvasContext.drawImage(placeholderImage, 0, 0, 300, 225);
        };
    };
    for (var i = 0; i < reelFrames.length; i++) {
        _loop_1(i);
    }
}
exports.setPlaceholders = setPlaceholders;
